import React, { useState } from "react";
import {
  Modal,
  Button,
  Card,
  Container,
  Row,
  Col,
  Form,
  Alert,
} from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { PlusCircle, Upload, Trash, Image } from "react-bootstrap-icons";
import Addphoto from "../../Images/Addphoto.svg";
const Photo = () => {
  const [photos, setPhotos] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [photoTitle, setPhotoTitle] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [previewFile, setPreviewFile] = useState(null);
  const [showAlert, setShowAlert] = useState(false);

  // Open & Close Modal
  const openModal = () => setShowModal(true);
  const closeModal = () => {
    setShowModal(false);
    setPhotoTitle("");
    setUploadedFile(null);
    setPreviewFile(null);
  };

  // React Dropzone Setup
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: "image/*",
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        setUploadedFile(file);
        setPreviewFile(URL.createObjectURL(file));
      }
    },
  });

  // Add Photo
  const handleAddPhoto = () => {
    if (photoTitle && uploadedFile) {
      const newPhoto = {
        id: Date.now(),
        title: photoTitle,
        file: URL.createObjectURL(uploadedFile),
      };
      setPhotos([newPhoto, ...photos]);
      setShowAlert(true);
      closeModal();

      setTimeout(() => setShowAlert(false), 3000);
    } else {
      alert("Please provide a title and upload a photo.");
    }
  };

  // Delete Photo
  const handleDeletePhoto = (id) => {
    setPhotos(photos.filter((photo) => photo.id !== id));
  };

  return (
    <div className="p-3">
      <Container>
        {/* Success Alert */}
        {showAlert && (
          <Alert
            variant="success"
            onClose={() => setShowAlert(false)}
            dismissible
            className="text-center fw-bold"
          >
            ✅ Photo added successfully!
          </Alert>
        )}

        {/* Add Photo Button */}
        <div className="d-flex justify-content-end mb-4">
          <Button
            variant=""
            onClick={openModal}
            className="d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow"
            style={{ fontSize: "16px", fontWeight: "bold",background:" #B8529E" ,color:"white"}}
          >
            <PlusCircle size={20} /> Add Photo
          </Button>
        </div>

        {/* Photo Grid or No Photos Found */}
        {photos.length === 0 ? (
  <div className="text-center text-muted p-5 border-0">
    <img src={Addphoto} alt="Add Photos" width={100} className="mb-3" /> {/* SVG Image */}
    <h5>No Photos Found</h5>
    <p className="text-secondary">
      Start adding your memories by clicking the button above.
    </p>
  </div>
        ) : (
          <Row className="gy-4">
            {photos.map((photo) => (
              <Col key={photo.id} md={4} sm={6} xs={12}>
                <Card className="shadow border-0 rounded-4 overflow-hidden position-relative">
                  {/* Delete Button */}
                  <Button
                    variant="danger"
                    className="position-absolute top-0 end-0 m-2 p-1 rounded-circle"
                    onClick={() => handleDeletePhoto(photo.id)}
                    style={{ width: "30px", height: "30px" }}
                  >
                    <Trash size={18} />
                  </Button>

                  <Card.Img
                    variant="top"
                    src={photo.file}
                    alt={photo.title}
                    className="rounded-top"
                    style={{
                      height: "200px",
                      objectFit: "contain", // Fixes zoomed-in issue
                      transition: "0.3s",
                      filter: "brightness(95%)",
                    }}
                  />
                  <Card.Body className="text-center bg-light">
                    <Card.Title className="text-truncate">{photo.title}</Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </Container>

      {/* Add Photo Modal */}
      <Modal show={showModal} onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Upload Photo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Photo Title Input */}
          <Form.Group controlId="photoTitle">
            <Form.Control
              type="text"
              placeholder="Enter photo title"
              value={photoTitle}
              onChange={(e) => setPhotoTitle(e.target.value)}
              className="mb-3"
            />
          </Form.Group>

          {/* Drag & Drop Upload Area */}
          <div
            {...getRootProps()}
            className={`border p-4 text-center rounded-3 shadow-sm ${
              isDragActive ? "bg-light" : ""
            }`}
            style={{
              cursor: "pointer",
              border: "2px dashed #007bff",
              transition: "0.2s",
            }}
          >
            <input {...getInputProps()} />
            {previewFile ? (
              <img
                src={previewFile}
                alt="Preview"
                className="img-fluid rounded shadow-sm"
                style={{
                  maxHeight: "200px",
                  width: "100%",
                  objectFit: "contain", // Fixes zoomed-in issue
                }}
              />
            ) : isDragActive ? (
              <p className="text-primary fw-bold">
                <Upload size={20} className="me-2" />
                Drop the image here...
              </p>
            ) : (
              <p className="text-muted">
                <Upload size={20} className="me-2" />
                Drag & drop an image here, or click to select
              </p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal} className="w-100 rounded-3 shadow-sm">
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAddPhoto} className="w-100 rounded-3 shadow-sm">
            Add Photo
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Photo;